module.exports = __webpack_public_path__ + "img/artboard13.f7ff1ea4.png";